// src/components/store/sections/gallery/GalleryV24ClayframesTealLagoon.tsx
"use client";

import React from "react";
import DynamicGalleryVariant from "./DynamicGalleryVariant";

export default function GalleryV24ClayframesTealLagoon(props: any) {
  return (
    <DynamicGalleryVariant
      variantNumber={24}
      archKey="clay_frames"
      archLabel="3D Clay Recessed Frames"
      palName="TealLagoon"
      grad="from-teal-500 via-cyan-600 to-emerald-700"
      lightBg="bg-teal-50"
      textCol="text-teal-700"
      borderCol="border-teal-200"
      btnCls="bg-teal-600 hover:bg-teal-700"
      hexCol="#14b8a6"
      {...props}
    />
  );
}
